import {times} from "lodash-es";
import {Checkbox} from "~/components/ui/checkbox.jsx";
import {useRef} from "react";
import {Label} from "~/components/ui/label.jsx";

export default function () {
  const refs = [];
  const handleChange = () => {
  }

  return (
    <div className="space-y-4">
      {times(100, n => {
        const ref = useRef(null);
        const id = `checkbox-${n}`;
        refs.push(ref)

        return (
          <div className="flex space-x-2" key={id}>
            <Checkbox value={id} ref={ref} id={id} onCheckedChange={handleChange}/>
            <Label htmlFor={id}>Check it {n}</Label>
          </div>
        )
      })}
    </div>
  )
}